import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ImageSize } from './style'
import Text from '@components/Text'
import Lightbox from '@components/LightBox'

// @TODO lazy loading library? better way to structure images, the sizes are based on bookCards.

const Image = (props) => {
  const {
    imageUrl,
    altText,
    size,
    caption,
    round = false,
    withLightbox = false,
  } = props
  const [showLightbox, setShowLightbox] = useState(false)
  const className = classNames(
    withLightbox && 'cursor-pointer',
    ImageSize[size],
    round ? 'rounded-full' : undefined
  )

  return (
    <>
      <img
        className={className}
        src={imageUrl}
        alt={altText}
        loading={'lazy'}
        onClick={withLightbox ? () => setShowLightbox(true) : undefined}
      />
      {caption && (
        <Text italic={true}>
          <span dangerouslySetInnerHTML={{ __html: caption }}></span>
        </Text>
      )}

      {withLightbox && (
        <Lightbox
          show={showLightbox}
          onClose={() => setShowLightbox(false)}
        >
          <img
            className={
              'relative max-h-full transform translate-x-[-50%] translate-y-[-50%] left-[50%] top-[50%] px-[100px] py-[50px]'
            }
            src={imageUrl}
          />
        </Lightbox>
      )}
    </>
  )
}

Image.propTypes = {
  imageUrl: PropTypes.string,
  altText: PropTypes.string,
  size: PropTypes.string,
  caption: PropTypes.string,
  round: PropTypes.bool,
  withLightbox: PropTypes.bool,
}

export default Image
